import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { Files, TrashFill } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { FaPen } from "react-icons/fa";
import { NumericFormat } from "react-number-format";
import FinancialOrderEnum from "../../../../../enums/FinancialOrderEnum";
import weightValidation from "../../../../../modules/pages/newLetter/functions/weight/weightValidation";
import calculateMass from "../functions/calculateMass";
import dimentionsValidations from "../functions/dimentionsValidations";
import generateRandomString from "../functions/generateRandomString";
import isCod from "../functions/isCod";
import maxCost from "../functions/maxCost";
import maxWeight from "../functions/maxWeight";
import style from "./ShipmentForm.module.css";
import Checkbox from "./checkbox/Checkbox";
import ContentBox from "./content/ContentBox";
import ContentShop from "./content/ContentShop";
import GetterAddressModal from "./getterAddress/GetterAddressModal";
import usePackage from "../../../../../hooks/usePackage";
import PackageSelect from "../../../../../components/Shipment/register/PackageSelect";
import useSharedData from "../../../../../hooks/useSharedData";

function ShipmentForm({
  index,
  register,
  shipment,
  errors,
  remove,
  getValues,
  control,
  insert,
  watch,
  setValue,
  isDirty,
  unregister,
  priceState: { prices, setPrices },
  lastPartNumber,
  type = 1,
  vipTariff,
  hasFinancialOrder,
}) {
  const { calculatePackagingPrice } = usePackage();
  const { isAgent } = useSharedData();

  const get = value => {
    try {
      return watch("items")[index][value];
    } catch (error) {
      return undefined;
    }
  };

  const getPrice = () => {
    try {
      const item = prices.find(item => item.ui === shipment.ui);
      return {
        price: item.price,
        totalPrice: item.totalPrice,
      };
    } catch (error) {
      return undefined;
    }
  };

  useEffect(() => {
    if (isDirty === true) {
      if (getPrice() !== undefined) {
        setPrices(cur => {
          const index = cur.findIndex(item => item.ui === shipment.ui);
          cur[index].price = 0;
          return [...cur];
        });
      }
    }
  }, [isDirty]);

  const [getterAddressModal, setGetterAddressModal] = useState(false);

  useEffect(() => {
    register(`items.${index}.getterAddress`, {
      value: shipment.getterAddress,
      required: { value: true, message: "آدرس الزامی" },
    });
  }, []);

  useEffect(() => {
    if (isCod() === false) {
      unregister(`items.${index}.amountCOD`);
    }
  }, [isCod()]);

  useEffect(() => {
    if (getPrice() !== undefined) {
      setPrices(cur => {
        const index = cur.findIndex(item => item.ui === shipment.ui);
        cur[index].price = 0;
        return [...cur];
      });
    }
  }, [get("getterAddressId")]);

  const calculateValues = () => {
    if (isAgent) {
      return 0;
    }

    if (!hasFinancialOrder(FinancialOrderEnum.CountPrice)) {
      return 0;
    }

    const monthRemain = vipTariff.monthRemain - getValues("items").length;
    if (monthRemain <= 0) {
      return 0;
    }

    const count = vipTariff.dayCount + getValues("items").length;
    let values = 50000;

    if (count <= 5) {
      values = 50000;
    } else if (count >= 6 && count <= 10) {
      values = 40000;
    } else if (count >= 11 && count <= 19) {
      values = 30000;
    } else if (count >= 20) {
      values = 0;
    }

    return values;
  };

  useEffect(() => {
    setValue(`items.${index}.countPrice`, calculateValues());
  }, [getValues("items").length, vipTariff.monthRemain]);

  return (
    <div>
      <div
        className={
          "d-flex flex-wrap position-relative " +
          style.formSection +
          (getPrice()?.price === 0 ? " " + style.shadowRed : "")
        }
      >
        <div className={style.partNumberBox}>
          <span>شماره پارت: </span>
          <span>{lastPartNumber + index}</span>
        </div>

        <Col xs={12} sm={6} md={3} lg={2} xxl={1}>
          <Form.Label>
            <span>وزن</span>
            <span>(کیلوگرم):</span>
          </Form.Label>
          <Form.Control
            type="number"
            step="0.0001"
            {...register(`items.${index}.weight`, {
              required: { value: true, message: "وزن الزامی" },
              value: shipment.weight,
              valueAsNumber: true,
              max: maxWeight(type),
              min: { value: 0.1, message: "حداقل وزن 100 گرم" },
              onBlur: type === 1 ? weightValidation : undefined,
            })}
          />
          {errors?.weight && <p>{errors?.weight?.message}</p>}
        </Col>

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>ابعاد(سانتی متر):</Form.Label>
          <div className="d-flex column-gap-1">
            <Form.Control
              type="number"
              placeholder="طول"
              {...register(`items.${index}.length`, {
                required: { value: true, message: "طول الزامی" },
                value: shipment.length,
                valueAsNumber: true,
                max: { value: 250, message: "حداکثر طول 250 کیلو سانتی متر" },
                min: { value: 1, message: "حداقل طول 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />

            <Form.Control
              type="number"
              placeholder="عرض"
              {...register(`items.${index}.width`, {
                required: { value: true, message: "عرض الزامی" },
                value: shipment.width,
                valueAsNumber: true,
                max: { value: 250, message: "حداکثر عرض 250 کیلو سانتی متر" },
                min: { value: 1, message: "حداقل عرض 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />

            <Form.Control
              type="number"
              placeholder="ارتفاع"
              {...register(`items.${index}.height`, {
                required: { value: true, message: "ارتفاع الزامی" },
                value: shipment.height,
                valueAsNumber: true,
                max: {
                  value: 250,
                  message: "حداکثر ارتفاع 250 کیلو سانتی متر",
                },
                min: { value: 1, message: "حداقل ارتفاع 1 سانتی متر" },
                onBlur: type === 1 ? dimentionsValidations : undefined,
              })}
            />
          </div>
          <div className="d-flex column-gap-1">
            <div className="flex-grow-1">
              {errors?.width && <p>{errors?.width?.message}</p>}
            </div>
            <div className="flex-grow-1">
              {errors?.length && <p>{errors?.length?.message}</p>}
            </div>
            <div className="flex-grow-1">
              {errors?.height && <p>{errors?.height?.message}</p>}
            </div>
          </div>
        </Col>

        <Col xs={12} sm={6} md={4} lg={3} xxl={2}>
          <Form.Label>وضعیت:</Form.Label>

          <div className="d-flex flex-wrap align-items-end mt-2">
            <Controller
              name={`items.${index}.isLiquid`}
              control={control}
              defaultValue={shipment.isLiquid}
              render={({ field: { onChange, value } }) => (
                <Checkbox title="مایعات" onChange={onChange} value={value} />
              )}
            />

            <Controller
              name={`items.${index}.isFragile`}
              control={control}
              defaultValue={shipment.isFragile}
              render={({ field: { onChange, value } }) => (
                <Checkbox
                  title="شکستنی"
                  className="me-3"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </div>
        </Col>

        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Label>نوع بسته بندی:</Form.Label>
          <Controller
            control={control}
            name={`items.${index}.packaging`}
            rules={{
              min: { value: 1, message: "انتخاب نوع بسته بندی الزامی" },
            }}
            render={({ field: { onChange, value } }) => (
              <PackageSelect onChange={onChange} value={value} />
            )}
          />
          {errors?.packaging && <p>{errors?.packaging?.message}</p>}
        </Col>

        {hasFinancialOrder(FinancialOrderEnum.Packaging) && (
          <Col xs={12} sm={6} md={3} xl={2}>
            <Form.Label>نیاز به بسته بندی:</Form.Label>

            <Controller
              name={`items.${index}.needPackaging`}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Checkbox title="دارم" onChange={onChange} value={value} />
              )}
            />
          </Col>
        )}

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
          <Form.Label>ارزش اظهار شده کالا:</Form.Label>

          <Controller
            control={control}
            name={`items.${index}.cost`}
            rules={{
              required: { value: true, message: "ارزش کالا الزامی" },
              max: maxCost(type),
            }}
            render={({ field: { ref, onChange } }) => (
              <NumericFormat
                getInputRef={ref}
                suffix="  ريال"
                onValueChange={inputValue => {
                  const { value } = inputValue;
                  onChange(value ? parseInt(value) : undefined);
                }}
                className="form-control"
                value={shipment.cost}
                thousandSeparator={true}
              />
            )}
          />
          {errors?.cost && <p>{errors?.cost?.message}</p>}
        </Col>

        {isCod() === true && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <Form.Label>مبلغ COD:</Form.Label>

            <Controller
              control={control}
              name={`items.${index}.amountCOD`}
              defaultValue={shipment.amountCOD ? shipment.amountCOD : 0}
              rules={{
                required: {
                  value: true,
                  message: "حداقل مبلغ cod صفر است (پسکرایه)",
                },
                min: { value: 0, message: "حداقل مبلغ cod صفر است (پسکرایه)" },
                validate: {
                  codAndCost: v => {
                    if (v > 0) {
                      if (v !== getValues(`items.${index}.cost`)) {
                        return "اگر مرسوله مبلغ cod دارد ، باید با ارزش کالا برابر باشد";
                      }
                    }

                    return true;
                  },
                },
              }}
              render={({ field: { ref, onChange, value } }) => (
                <NumericFormat
                  getInputRef={ref}
                  suffix="  ريال"
                  onValueChange={inputValue => {
                    const { value } = inputValue;
                    onChange(value ? parseInt(value) : undefined);
                  }}
                  className="form-control"
                  value={value}
                  thousandSeparator={true}
                />
              )}
            />
            {errors?.amountCOD && <p>{errors?.amountCOD?.message}</p>}
          </Col>
        )}

        {type === 2 && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <div className="d-flex flex-wrap align-items-end pb-2 h-100">
              <Controller
                name={`items.${index}.outOfArea`}
                control={control}
                defaultValue={shipment.isFragile}
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    title="مقصد خارج از محدوده شهری"
                    className="me-3"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </Col>
        )}

        {hasFinancialOrder(FinancialOrderEnum.serviceInPlace) && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <Form.Label>خدمات در محل:</Form.Label>
            <Controller
              control={control}
              name={`items.${index}.serviceInPlace`}
              defaultValue={shipment.serviceInPlace}
              rules={{
                max: { value: 3000000, message: "حداکثر مبلغ 300 هزار تومن" },
              }}
              render={({ field: { ref, onChange, value } }) => (
                <NumericFormat
                  getInputRef={ref}
                  suffix="  ريال"
                  onValueChange={inputValue => {
                    const { value } = inputValue;
                    onChange(value !== "" ? parseInt(value) : 0);
                  }}
                  className="form-control"
                  value={value}
                  thousandSeparator={true}
                />
              )}
            />
            {errors?.serviceInPlace && <p>{errors?.serviceInPlace?.message}</p>}
          </Col>
        )}

        {hasFinancialOrder(FinancialOrderEnum.CountPrice) && (
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <Form.Label>تعرفه تعداد :</Form.Label>
            <Controller
              control={control}
              name={`items.${index}.countPrice`}
              render={({ field: { ref } }) => (
                <NumericFormat
                  getInputRef={ref}
                  suffix="  ريال"
                  className="form-control"
                  value={calculateValues(index)}
                  thousandSeparator={true}
                  readOnly
                  disabled
                />
              )}
            />
            {errors?.countPrice && <p>{errors?.countPrice?.message}</p>}
          </Col>
        )}

        {type === 1 && (
          <ContentShop
            register={register}
            index={index}
            errors={errors}
            unregister={unregister}
            content={shipment.content}
          />
        )}

        {type === 2 && (
          <ContentBox
            register={register}
            index={index}
            errors={errors}
            content={shipment.content}
          />
        )}

        <div className="w-100">
          <Form.Label>
            <button
              className="buttonUi btn-success-style"
              style={{ width: 180 }}
              onClick={() => setGetterAddressModal(true)}
              type="button"
            >
              <div className="d-flex align-items-center">
                <span>انتخاب آدرس گیرنده</span>
                <span className="me-2">
                  <FaPen />
                </span>
              </div>
            </button>
          </Form.Label>
          <input
            type="number"
            className={style.inputHidden}
            {...register(`items.${index}.getterAddressId`, {
              value: shipment.getterAddressId,
              required: { value: true, message: "آدرس الزامی" },
            })}
          />
          <Form.Control
            as="textarea"
            disabled={true}
            value={get("getterAddress")?.totalAddress}
          />

          {(!get("getterAddress") || !get("getterAddressId")) && (
            <p>{errors?.getterAddress?.message}</p>
          )}
        </div>

        <div className="w-100 d-flex flex-wrap column-gap-4">
          <p className="text-secondary fs-6">
            <strong>وزن حجمی: </strong>
            <strong>
              {calculateMass({
                width: get("width"),
                height: get("height"),
                length: get("length"),
              })}
            </strong>
          </p>

          {hasFinancialOrder(FinancialOrderEnum.Packaging) && (
            <p className="text-secondary fs-6">
              <strong>هزینه بسته بندی: </strong>
              <strong>
                {calculatePackagingPrice({
                  type: get("packaging"),
                  width: get("width"),
                  height: get("height"),
                  length: get("length"),
                  need: get("needPackaging"),
                }).toLocaleString()}
              </strong>
            </p>
          )}
        </div>

        <div className="w-100 d-flex flex-wrap justify-content-between align-items-center mt-1 mt-md-2">
          {getPrice() !== undefined &&
            (() => {
              const { price, totalPrice } = getPrice();
              return (
                <>
                  <p className="fs-5 text-black pe-md-4">
                    <span>قیمت بارکد پستی : </span>
                    <span className="fs-4 text-primary fw-bold">
                      {isNaN(price) ? "0" : price?.toLocaleString()}
                    </span>
                    <span> ریال</span>
                  </p>
                  <p className="fs-5 text-black pe-md-4">
                    <span>قیمت نهایی: </span>
                    <span className="fs-4 text-primary fw-bold">
                      {isNaN(totalPrice) ? "0" : totalPrice?.toLocaleString()}
                    </span>
                    <span> ریال</span>
                  </p>
                </>
              );
            })()}
          <div className="me-auto">
            <button
              className="buttonUi"
              type="button"
              onClick={() => {
                setPrices(cur => cur.filter(item => item.ui !== shipment.ui));
                remove(index);
              }}
            >
              <span>
                <TrashFill color="red" />
              </span>
            </button>

            <button
              className="buttonUi"
              type="button"
              onClick={() =>
                insert(index + 1, {
                  ...getValues("items")[index],
                  ui: generateRandomString(),
                })
              }
            >
              <span>
                <Files color="blue" />
              </span>
            </button>
          </div>
        </div>
      </div>
      {getterAddressModal === true && (
        <GetterAddressModal
          close={() => setGetterAddressModal(false)}
          set={data => {
            setValue(`items.${index}.getterAddressId`, data.address.id);
            setValue(`items.${index}.getterAddress`, data.address);
            setGetterAddressModal(false);
          }}
        />
      )}
    </div>
  );
}

export default ShipmentForm;
